import { MGST } from "../../schemas/mg.schema-types.js";
import { PGSchema } from "../../schemas/pg.schema.js";

export let CombinedReports: PGSchema.test_reports[] = [
	{
		id: BigInt(1),
		created_at: new Date(),
		updated_at: new Date(),
		name: "Remote Ready Overall",
		description: "Remote Ready Overall",
		type: 1,
		tids: [MGST.test.tid._16PF, MGST.test.tid.INTEGRITYX, MGST.test.tid.PPC_G, MGST.test.tid.ENGLISH_LEVEL, MGST.test.tid.INTERESES_VOCACIONALES, MGST.test.tid.REMOTE_READINESS]
	}
];
